import { GamesActionTypes } from "./actionTypes";

export const GamesActionCreators = {
    getGameConfigurations: ({
        page = 0,
        top = 10,
        subsidiary,
        gameEngine,
        status,
        gameId
    }) => ({
        type: GamesActionTypes.GET_GAME_CONFIGURATIONS,
        payload: { page, top, subsidiary, gameEngine, status, gameId }
    }),

    getGames: ({
        page = 0,
        top = 10,
        search,
        type,
        software_house,
        deprecated
    }) => ({
        type: GamesActionTypes.GET_GAMES,
        payload: { page, top, search, type, software_house, deprecated }
    }),

    searchGames: search => ({
        type: GamesActionTypes.SEARCH_GAMES,
        payload: { search }
    }),

    clearSearchGames: () => ({
        type: GamesActionTypes.CLEAR_SEARCH_GAMES
    }),

    getSubsidiaries: () => ({
        type: GamesActionTypes.GET_SUBSIDIARIES
    }),

    getGameCategories: () => ({
        type: GamesActionTypes.GET_GAME_CATEGORIES
    }),

    saveGameCategory: (category, subsidiaryIds) => ({
        type: GamesActionTypes.SAVE_GAME_CATEGORY,
        payload: {category, subsidiaryIds}
    }),

    deleteGameCategory: categoryId => ({
        type: GamesActionTypes.DELETE_GAME_CATEGORY,
        payload: {categoryId}
    }),

    getGameEngines: () => ({
        type: GamesActionTypes.GET_GAME_ENGINES
    }),

    /*getGameConfiguration: gameId => ({
        type: GamesActionTypes.GET_GAME_CONFIGURATION,
        payload: { gameId }
    }),*/

    getGame: gameId => ({
        type: GamesActionTypes.GET_GAME,
        payload: { gameId }
    }),

    updateCreationMode: mode => ({
        type: GamesActionTypes.CREATION_MODE_CHANGE,
        payload: {
            mode
        }
    }),

    updateCreatingGame: (values, isValid) => ({
        type: GamesActionTypes.UPDATE_CREATING_GAME,
        payload: {
            values,
            isValid
        }
    }),

    updateCreatingConf: (values, isValid) => ({
        type: GamesActionTypes.UPDATE_CREATING_CONF,
        payload: {
            values,
            isValid
        }
    }),

    clearCreateGame: () => ({
        type: GamesActionTypes.CREATE_GAME_RESET
    }),

    clearCreateConfiguration: () => ({
        type: GamesActionTypes.CREATE_CONF_RESET
    }),

    getEnginesSchemas: () => ({
        type: GamesActionTypes.GET_GAME_ENGINES_SCHEMAS
    }),

    editGame: (game, refreshData) => ({
        type: GamesActionTypes.EDIT_GAME,
        payload: {
            game,
            refreshData
        }
    }),

    createGame: (game, refreshData) => ({
        type: GamesActionTypes.CREATE_GAME,
        payload: {
            game,
            refreshData
        }
    }),

    editConfiguration: (conf, refreshData) => ({
        type: GamesActionTypes.EDIT_CONF,
        payload: {
            conf,
            refreshData
        }
    }),

    createConfiguration: (conf, refreshData) => ({
        type: GamesActionTypes.CREATE_CONF,
        payload: {
            conf,
            refreshData
        }
    }),

    deleteConfiguration: (id, refreshData) => ({
        type: GamesActionTypes.DELETE_CONF,
        payload: {
            id,
            refreshData
        }
    }),

    moveConfiguration: (conf, gameId, refreshData) => ({
        type: GamesActionTypes.MOVE_GAME_CONF,
        payload: {
            conf,
            gameId,
            refreshData
        }
    }),

    getGameBundles: ({ page = 0, top = 10, search }) => ({
        type: GamesActionTypes.GET_BUNDLES,
        payload: { page, top, search }
    }),

    updateCreatingBundle: (values, isValid) => ({
        type: GamesActionTypes.UPDATE_CREATING_BUNDLE,
        payload: {
            values,
            isValid
        }
    }),

    clearCreateBundle: () => ({
        type: GamesActionTypes.CREATE_BUNDLE_RESET
    }),

    createBundle: (bundle, refreshData) => ({
        type: GamesActionTypes.CREATE_BUNDLE,
        payload: {
            bundle,
            refreshData
        }
    }),

    editBundle: (bundle, refreshData) => ({
        type: GamesActionTypes.EDIT_BUNDLE,
        payload: {
            bundle,
            refreshData
        }
    }),

    deleteBundle: (id, refreshData) => ({
        type: GamesActionTypes.DELETE_BUNDLE,
        payload: {
            id,
            refreshData
        }
    }),

    getSubsidiaryConfigurations: subsidiary => ({
        type: GamesActionTypes.GET_SUBSIDIARY_CONFIGURATIONS,
        payload: {
            subsidiary
        }
    }),

    loadJson: json => ({
        type: GamesActionTypes.LOAD_JSON,
        payload: {
            json
        }
    }),

    errorJson: error => ({
        type: GamesActionTypes.LOAD_JSON_FAIL,
        payload: {
            error: error
        }
    }),

    activateConfiguration: (conf, refreshData) => ({
        type: GamesActionTypes.ACTIVATE_CONF,
        payload: {
            id: conf,
            refreshData
        }
    }),

    createAlias: (json, alias) => ({
        type: GamesActionTypes.CREATE_ALIAS,
        payload: {
            json,
            alias
        }
    }),
    getGameAttributes: client => ({
        type: GamesActionTypes.GET_GAME_ATTRIBUTES,
        payload: { client }
    }),

    getClients: () => ({
        type: GamesActionTypes.GET_CLIENTS
    }),

    getGameFeatures: client => ({
        type: GamesActionTypes.GET_GAME_ATTRIBUTES_FEATURES,
        payload: { client }
    }),

    getGameSeries: client => ({
        type: GamesActionTypes.GET_GAME_ATTRIBUTES_SERIES,
        payload: { client }
    }),

    getGamePlaftorms: client => ({
        type: GamesActionTypes.GET_GAME_ATTRIBUTES_PLATFORM,
        payload: { client }
    }),

    getGameTypes: client => ({
        type: GamesActionTypes.GET_GAME_ATTRIBUTES_TYPE,
        payload: { client }
    }),

    getGameTrademarks: client => ({
        type: GamesActionTypes.GET_GAME_ATTRIBUTES_TRADEMARKS,
        payload: { client }
    }),

    editGameAttribute: (values, client) => ({
        type: GamesActionTypes.EDIT_GAME_ATTRIBUTE,
        payload: { values, client }
    }),

    createGameAttribute: (values, client) => ({
        type: GamesActionTypes.CREATE_GAME_ATTRIBUTE,
        payload: { values, client }
    }),

    updateAttrCreationMode: mode => ({
        type: GamesActionTypes.CREATION_ATTR_MODE_CHANGE,
        payload: {
            mode
        }
    }),

    getGameCreationAttributes: () => ({
        type: GamesActionTypes.GET_GAME_CREATION_ATTRIBUTES
    }),

    getDenominations: () => ({
        type: GamesActionTypes.GET_DENOMINATIONS
    })

};
